// 世界史スポットの学習進捗（訪問済み・クイズ正誤）を localStorage に保存する。
//
// aircraft.js の MODEL_YAW_KEY と同じ作法で、バージョン付きキー＋全アクセス try/catch。
// Safari のプライベートモードや Cookie ブロック下では localStorage の
// プロパティアクセス自体が投げうるので、getItem/setItem を try の内側に置く。
// 保存に失敗してもゲームは通常どおり動き、そのセッション中だけ進捗が生きる。
const KEY = 'historicSitesProgressV1';
const ONBOARD_KEY = 'historicSitesOnboardedV1';

function loadRaw() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return {};
    const data = JSON.parse(raw);
    if (data && typeof data === 'object' && data.sites && typeof data.sites === 'object') {
      return data.sites;
    }
    return {};
  } catch {
    return {}; // 破損 JSON / ストレージ無効
  }
}

export function createProgress() {
  const sites = loadRaw(); // { [id]: { t: 訪問時刻(ms), q: 1|0|null クイズ正誤 } }
  // 件数は保持しておく（毎フレーム読まれても Object.keys の配列を作らないように）。
  let count = Object.keys(sites).length;

  function save() {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ v: 1, sites }));
    } catch {
      /* 容量超過・プライベートモード: メモリ上の進捗だけ維持して続行 */
    }
  }

  return {
    has(id) {
      return Object.prototype.hasOwnProperty.call(sites, id);
    },
    get size() {
      return count;
    },
    // 初訪問なら true を返す（＝リングの色替えやトーストの発火条件に使う）。
    mark(id) {
      if (this.has(id)) return false;
      sites[id] = { t: Date.now(), q: null };
      count++;
      save();
      return true;
    },
    // クイズの正誤。未訪問 id は無視（mark が先に呼ばれる前提）。
    setQuiz(id, correct) {
      if (!this.has(id)) return;
      sites[id].q = correct ? 1 : 0;
      save();
    },
    // 初回の遊び方トーストを出したか。localStorage が使えない環境では
    // 「出した」扱いにして、毎回うるさく出ないようにする。
    isOnboarded() {
      try {
        return !!window.localStorage.getItem(ONBOARD_KEY);
      } catch {
        return true;
      }
    },
    markOnboarded() {
      try {
        window.localStorage.setItem(ONBOARD_KEY, '1');
      } catch {
        /* 保存できなくても可 */
      }
    },
    reset() {
      for (const k of Object.keys(sites)) delete sites[k];
      count = 0;
      save();
    },
  };
}

// 都市を選び直して再出発しても進捗は引き継ぐので、モジュール singleton にする
// （AIRPORTS などと同じ扱い）。
export const progress = createProgress();
